import { render, staticRenderFns } from "./styleForm.vue?vue&type=template&id=0fda8a8a&scoped=true&"
import script from "./styleForm.vue?vue&type=script&lang=js&"
export * from "./styleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fda8a8a",
  null
  
)

export default component.exports